import React, { useState } from "react"
import MetaTags from "react-meta-tags"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  CustomInput,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

export default function AddUser() {
  return ( 
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add User | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Add User" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="UserName">User Name</Label>
                          <AvField
                            name="UserName"
                            placeholder="User Name"
                            type="text"
                            errorMessage="Please Enter User Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="UserName"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="MobileNo">Mobile No</Label>
                          <AvField
                            name="MobileNo"
                            placeholder="Mobile No"
                            type="text"
                            errorMessage="Please Enter Mobile No"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="MobileNo"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="EmailID">Email ID</Label>
                          <AvField
                            name="EmailID"
                            placeholder="Email ID"
                            type="text"
                            errorMessage="Please Enter Email ID."
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="EmailID"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="Branch">Branch</Label>
                          <AvField
                            name="Branch"
                            placeholder="Branch"
                            type="text"
                            errorMessage="Please Enter Branch"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="Branch"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label className="mb-3" htmlFor="AssignRole">Assign Role</Label><br/>
                          {/* <AvField
                            name="AssignRole"
                            placeholder="Assign Role"
                            type="text"
                            errorMessage="Please Enter Assign Role"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="AssignRole"
                          /> */}

                          <Input
                            type="checkbox"
                            className="form-check-input"
                            id="Add"
                          />&nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="Add"
                          >
                            {" "}
                            Add
                          </Label>
                          &nbsp;&nbsp;&nbsp;
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            id="Accept"
                          />&nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="Accept"
                          >
                            {" "}
                            Accept
                          </Label>
                          &nbsp;&nbsp;&nbsp;
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            id="Delete"
                          />&nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="Delete"
                          >
                            {" "}
                            Delete
                          </Label>
                          &nbsp;&nbsp;&nbsp;
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            id="Edit"
                          />&nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="Edit"
                          >
                            {" "}
                            Edit
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col lg="12">
                        <FormGroup className="mb-3">
                          <div className="form-check">
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="invalidCheck"
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="invalidCheck"
                            >
                              {" "}
                              Agree to terms and conditions
                            </Label>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row> */}
                    <Button color="primary" type="submit">
                      Submit form
                    </Button>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
